import script from "./WatchListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchListCard.vue?vue&type=script&setup=true&lang=js"

import "./WatchListCard.vue?vue&type=style&index=0&id=1b400ae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b400ae2"]])

export default __exports__